export default {

  /**
   * Receives a permission matrix and a set of requirements they must meet.
   * @param {*} permissions The permission matrix as a JSON object.
   * @param {*} requirements The requirements to be met as a JSON object.
   * @return {*} If user's requirements meet the requested requirements.
   */
  checkRequirements (permissions, requirements) {
    // If the route requires at least one of the requirements
    if (requirements.eitherOneOf) {
      let reqMet = false
      for (let req in requirements.eitherOneOf) {
        reqMet = reqMet || isAllowedTo(permissions, req)
      }

      if (!reqMet) {
        return false
      }
    }

    // If all of the requirements are met
    if (requirements.allOf) {
      for (let req in requirements.allOf) {
        if (!isAllowedTo(permissions, req)) {
          return false
        }
      }
    }

    return true
  }
}

/**
 * Receives a premissionMatrix and determines if the user is allowed to do this.
 * @param {*} permissions Permission matrix as a object of permissions
 * @param {*} action THe action attempted to be performed
 * @returns {*} If the user is allowed to perform this action
 */
function isAllowedTo (permissions, action) {
  return permissions[action] || false
}



// WEBPACK FOOTER //
// ./src/assets/modules/permissions/permissionChecker.js